module.exports = __webpack_public_path__ + "static/media/relaxtempolibero.10282f4d.png";